/* Publish by EComposer at 2025-08-11 05:35:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lljjnllvyz"]=  window.__ectimmers["ecom-lljjnllvyz"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lljjnllvyz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lljjnllvyz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-16lka8lxv9gi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-16lka8lxv9gi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nq8bqxe4ea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nq8bqxe4ea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dq5ra6iaqdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dq5ra6iaqdj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ku0e1sx2wa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ku0e1sx2wa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b4wil6o4pji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4wil6o4pji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2rqvkhxtro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2rqvkhxtro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6v0cx170v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6v0cx170v', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9mqf0xsy4p"]=  window.__ectimmers["ecom-9mqf0xsy4p"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-9mqf0xsy4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mqf0xsy4p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqhdfgd2jab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqhdfgd2jab', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtbs51n2eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtbs51n2eh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}